import { render, staticRenderFns } from "./UCIrvineELN2V2QuantitativeObservations1.vue?vue&type=template&id=4b328c9a&scoped=true&"
import script from "./UCIrvineELN2V2QuantitativeObservations1.vue?vue&type=script&lang=ts&"
export * from "./UCIrvineELN2V2QuantitativeObservations1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b328c9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VForm,VRow})
